import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { StrainImageModel } from "@app/strain/common/models/view-measurement-models/strain-image.model";

@Component({
    selector: 'app-strain-measurement-image',
    templateUrl: './strain-measurement-image.component.html',
    styleUrls: ['./strain-measurement-image.component.scss']
})
export class StrainMeasurementImageComponent implements OnInit {
    @Input() image: StrainImageModel;
    @Output() resetImage = new EventEmitter<any>();

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
    }


    changeImage($event: MouseEvent) {
        $event.preventDefault();
        this.resetImage.emit(this.image.id);
    }

    getSanitizedUrl(url: string) {
        if (!url || url === 'undefined') {
            return '';
        }
        return this.sanitizer.bypassSecurityTrustUrl(url)
    }
}
